import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Fetches current period
 *
 */

const months = [
  { name: 'Enero', id: 1 },
  { name: 'Febrero', id: 2 },
  { name: 'Marzo', id: 3 },
  { name: 'Abril', id: 4 },
  { name: 'Mayo', id: 5 },
  { name: 'Junio', id: 6 },
  { name: 'Julio', id: 7 },
  { name: 'Agosto', id: 8 },
  { name: 'Septiembre', id: 9 },
  { name: 'Octubre', id: 10 },
  { name: 'Noviembre', id: 11 },
  { name: 'Diciembre', id: 12 },
]

const currentPeriod = () =>
  Vue.$http.get('user/period/current/')
    .then((res) => {
      const period = res.data && res.data[0]
      const monthName = months.find(m => m.id === period.month)
      return { ...period, monthName: monthName.name }
    })
    .catch((err) => {
      throw err
    })

export default currentPeriod


// WEBPACK FOOTER //
// ./src/services/user/currentPeriod.js